exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-info[data-v-3a4968fa]{font-size:13px;margin-bottom:10px}.comment-author[data-v-3a4968fa]{font-weight:500}.comment-date[data-v-3a4968fa]{color:#42526e}.comment-item[data-v-3a4968fa]{position:relative;padding:15px 0;border-bottom:1px solid #ccc}.comment-item:hover .comment-controls[data-v-3a4968fa]{display:block}.comment-controls[data-v-3a4968fa]{display:none;position:absolute;top:0;right:0}.new-comment[data-v-3a4968fa]{margin-top:20px}.manager[data-v-3a4968fa]{position:relative;margin:10px 0;min-height:32px;outline:0;padding:2px 0 8px}.manager[data-v-3a4968fa]:before{content:\"\";position:absolute;bottom:0;left:0;right:0;background:currentColor;height:1px;color:#bdbdbd;-webkit-transform:scaleY(1);transform:scaleY(1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a4968fa","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/ProjectDetailsView.vue
// module id = 2rk3
// module chunks = 0